import DeployContestButton from './DeployContestButton.container'

export default DeployContestButton
